<div *ngIf="planUUID && !existingPlan">
    <h3>Plan not found</h3>
</div>

<div id="create-plan-form">
    <form fxFlex="50%" fxLayout="column" fxLayoutGap="15px" [formGroup]="form" *ngIf="!planUUID || (planUUID && existingPlan)">
        <div>
            <mat-form-field fxFlex>
                <input type="text" placeholder="Plan name" matInput formControlName="name" />
                <mat-error *ngIf="controls.name.errors && (controls.name.dirty || controls.name.touched) && controls.name.errors?.required">
                    Plan name is <strong>required</strong>.
                </mat-error>
            </mat-form-field>

            <div fxLayout="row" fxLayoutGap="20px">
                <mat-form-field fxFlex>
                    <input type="text" placeholder="Start date" matInput formControlName="startDate" [matDatepicker]=startDatepicker />
                    <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
                    <mat-datepicker #startDatepicker></mat-datepicker>
                    <mat-error *ngIf="controls.startDate.errors && (controls.startDate.dirty || controls.startDate.touched) && controls.startDate.errors?.required">
                        The start date of the plan is <strong>required</strong>.
                    </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex>
                    <input type="number" placeholder="Number of weeks" matInput formControlName="numWeeks" />
                    <mat-error *ngIf="controls.numWeeks.errors && (controls.numWeeks.dirty || controls.numWeeks.touched) && controls.numWeeks.errors?.required">
                        Plan length in weeks is <strong>required</strong>.
                    </mat-error>
                    <mat-error *ngIf="controls.numWeeks.errors && controls.numWeeks.errors?.min">
                        Plan must be a minimum of 1 week long.
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <textarea class="create-plan_notes" placeholder="Notes" rows="5" formControlName="notes"></textarea>

        <button id="checkmark-button" mat-fab class="fixed-fab" color="primary" type="submit" (click)="createPlan()" [disabled]="form.invalid">
      <mat-icon *ngIf="!loading">check</mat-icon>
      <mat-spinner diameter="24" strokeWidth="4" *ngIf="loading"></mat-spinner>
    </button>
    </form>
</div>

<ngx-guided-tour></ngx-guided-tour>